// @theme component
import { useMemo } from 'react';
import { required, regexp, length } from '@core/js/utils/Validation/validationRules';

type ValidationConfigParams = {
    t: (key: string) => string,
    field: 'cellphone'
}

export const useValidationConfig = ({ t, field }: ValidationConfigParams) => {
    const validations = useMemo(() => ({
        cellphone: [
            required({ error: t('validation.required') }),
            regexp({
                re: /^[0-9]+$/,
                error: t('validation.regexp')
            }),
            length({
                min: 10,
                max: 10,
                error: t('validation.length')
            })]
    }), [t]);

    return { [field]: validations[field] } as any;
};
